import Icon from './Icon.vue';
import IconPicker from './IconPicker.vue';

export default [
  Icon,
  IconPicker,
];
